import { AlertTriangle, TrendingUp, TrendingDown, Timer, Users, Inbox } from "lucide-react";
import { fmtDays, fmtHours } from "./format";

export function buildInsights(a) {
  const k = a.kpis;
  const out = [];
  if (k.stuck > 0) {
    const top = a.stuck_files[0];
    out.push({ tone: "red", icon: AlertTriangle, title: `${k.stuck} file${k.stuck > 1 ? "s" : ""} idle for over a week`,
      body: top ? `Oldest: "${top.name}" has been with ${top.holder_name} for ${Math.floor(top.days)} days.` : "" });
  }
  if (k.created || k.closed) {
    const rate = k.created ? Math.round((k.closed / k.created) * 100) : 100;
    const growing = k.created > k.closed;
    out.push({ tone: growing ? "orange" : "teal", icon: growing ? TrendingUp : TrendingDown,
      title: `Closure rate ${rate}% this period`,
      body: growing ? `${k.created - k.closed} more files opened than closed — backlog is growing.` : "Files are being closed as fast as they arrive — backlog is under control." });
  }
  if (k.avg_turnaround_days !== null) {
    const prev = k.avg_turnaround_days_prev;
    const cmp = prev !== null && prev !== undefined ? (k.avg_turnaround_days <= prev ? `faster than ${fmtDays(prev)} last period` : `slower than ${fmtDays(prev)} last period`) : "no earlier period to compare";
    out.push({ tone: "navy", icon: Timer, title: `Files close in ${fmtDays(k.avg_turnaround_days)} on average`, body: `From creation to closure — ${cmp}.` });
  }
  const busiest = a.pending_by_holder[0];
  if (busiest && busiest.count > 1) {
    out.push({ tone: "orange", icon: Users, title: `${busiest.name} holds ${busiest.count} open files`,
      body: `Largest pending queue; oldest has waited ${Math.floor(busiest.oldest_days)} days.` });
  }
  if (k.waiting_with_me > 0) {
    out.push({ tone: "navy", icon: Inbox, title: `${k.waiting_with_me} file${k.waiting_with_me > 1 ? "s" : ""} waiting for you`,
      body: k.my_avg_response_hours !== null ? `Your average response this period: ${fmtHours(k.my_avg_response_hours)}.` : "Clear these to keep movement flowing." });
  }
  return out.slice(0, 4);
}

const TONES = { red: "#E63946", orange: "#F4A261", teal: "#2A9D8F", navy: "#1D3557" };

export function Insights({ items }) {
  if (!items.length) return null;
  return (
    <div className="grid gap-4 grid-cols-[repeat(auto-fit,minmax(260px,1fr))]" data-testid="insights">
      {items.map((it, i) => (
        <div key={i} data-testid={`insight-${i}`} className="bg-white border border-[#DCD9D0] p-5 flex gap-3 transition-colors duration-150 hover:border-[#1D3557]" style={{ borderLeft: `4px solid ${TONES[it.tone]}` }}>
          <it.icon size={18} style={{ color: TONES[it.tone] }} className="shrink-0 mt-0.5" />
          <div className="min-w-0">
            <div className="font-heading font-bold text-[15px] leading-snug">{it.title}</div>
            <div className="text-[12.5px] text-[#5C5C54] mt-1 leading-relaxed">{it.body}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
